module.exports = __webpack_public_path__ + "static/img/insidecopper.850c5fee.png";